import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/motion";
import Manifesto from "@/components/home/Manifesto";
import { BRAND } from "@/data/site";

export default function ManifestoPage() {
  return (
    <div data-testid="manifesto-page">
      <Seo
        title="Why NC?"
        description="The operating beliefs that shape every session, every document, and every piece of advice North Cadence gives — to every professional and every organisation that works with us."
      />
      <PageHero
        eyebrow="Why NC?"
        title={["What we believe about growth", "and the people behind it."]}
        subtitle="These are not aspirations. They are the operating beliefs that shape every session, every document, and every piece of advice we give — to every professional and every organisation that works with us."
      />

      <Manifesto compact />

      <section className="bg-white py-8">
        <div className="nc-container flex flex-col items-center gap-6 text-center">
          <Reveal>
            <p className="font-display text-2xl sm:text-3xl font-bold italic text-[#142A5E]">
              "{BRAND.tagline}"
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-[#1B1B1B]/50">— North Cadence</p>
          </Reveal>
          {/* <Reveal delay={0.15}>
            <Link
              to="/contact"
              className="group mt-4 inline-flex items-center gap-2 rounded-full bg-[#142A5E] px-7 py-4 font-semibold text-white transition-colors hover:bg-[#0d1c40]"
            >
              Book a Free Discovery Call
              <ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </Reveal> */}
        </div>
      </section>
    </div>
  );
}
